/* eslint-disable max-len */

import _ from 'lodash';

import {
  VOCABULARY_LIST_DRILLDOWN_SET_CURRENT_VOCABULARY_NAME,
  VOCABULARY_LIST_DRILLDOWN_SET_CURRENT_VOCABULARY_TERMS,
  VOCABULARY_LIST_DRILLDOWN_EDITING_SET_SEARCH_TERM,
  VOCABULARY_LIST_DRILLDOWN_SET_TERM_WEIGHT,
  VOCABULARY_LIST_DRILLDOWN_SET_TERM,
  VOCABULARY_LIST_DRILLDOWN_EDITING_SET_IS_EDITING_VOCABULARY,
  VOCABULARY_LIST_DRILLDOWN_EDITING_SET_CURRENT_TERM_CHECKLIST,
  VOCABULARY_LIST_DRILLDOWN_SET_EDITING_VOCABULARY_NAME,
  VOCABULARY_LIST_DRILLDOWN_EDITING_RESET,
  VOCABULARY_LIST_DRILLDOWN_FETCH_TERM,

  VOCABULARY_LIST_DRILLDOWN_SET_VOCABULARY_STATE,
  VOCABULARY_LIST_DRILLDOWN_SET_VOCABULARY_STATE_LOADED,
  VOCABULARY_LIST_DRILLDOWN_SET_VOCABULARY_STATE_LOADING,
  VOCABULARY_LIST_DRILLDOWN_SET_VOCABULARY_STATE_NOT_LOADED,
  VOCABULARY_LIST_DRILLDOWN_SET_VOCABULARY_STATE_LOAD_ERROR,
  VOCABULARY_LIST_DRILLDOWN_VOCABULARY_STATE_NOT_LOADED,
  VOCABULARY_LIST_DRILLDOWN_VOCABULARY_STATE_LOADING,
  VOCABULARY_LIST_DRILLDOWN_VOCABULARY_STATE_LOAD_ERROR,
  VOCABULARY_LIST_DRILLDOWN_VOCABULARY_STATE_LOADED,
  VOCABULARY_LIST_DRILLDOWN_VOCABULARY_STATE_DELETED,
  VOCABULARY_LIST_DRILLDOWN_SET_SOUNDSLIKE,
  VOCABULARY_LIST_DRILLDOWN_INIT_NEW,

  VOCABULARY_LIST_DRILLDOWN_SET_EDITING_STATE,
  VOCABULARY_LIST_DRILLDOWN_SET_EDITING_STATE_NOT_LOADED,
  VOCABULARY_LIST_DRILLDOWN_SET_EDITING_STATE_LOADING,
  VOCABULARY_LIST_DRILLDOWN_SET_EDITING_STATE_LOADED,
  VOCABULARY_LIST_DRILLDOWN_SET_EDITING_STATE_LOAD_ERROR,
  VOCABULARY_LIST_DRILLDOWN_EDITING_SAVE,
  VOCABULARY_LIST_DRILLDOWN_EDITING_DESTROY,

  VOCABULARY_LIST_DRILLDOWN_EDITING_STATE_NOT_LOADED,
  VOCABULARY_LIST_DRILLDOWN_EDITING_STATE_LOADING,
  VOCABULARY_LIST_DRILLDOWN_EDITING_STATE_LOADED,
  VOCABULARY_LIST_DRILLDOWN_EDITING_STATE_ERROR,
  VOCABULARY_LIST_DRILLDOWN_DELETE_CHECKED_TERMS,
  VOCABULARY_LIST_DRILLDOWN_SET_EDIT_VOCABULARY_WEIGHT,
  VOCABULARY_LIST_DRILLDOWN_SET_EDITING_VOCABULARY_TERMS,

  VOCABULARY_LIST_DRILLDOWN_SET_IS_NEW,

  VOCABULARY_LIST_DRILLDOWN_START_ADDING_VOCABULARY,
  VOCABULARY_LIST_DRILLDOWN_SAVE_ADDING_VOCABULARY,
  VOCABULARY_LIST_DRILLDOWN_STOP_ADDING_VOCABULARY,

  VOCABULARY_LIST_DRILLDOWN_SAVE_ADDING_VOCABULARY_TERMS,
  VOCABULARY_LIST_DRILLDOWN_ADDING_STATE_NOT_ADDING_VOCABULARY,
  VOCABULARY_LIST_DRILLDOWN_ADDING_STATE_ADDING_VOCABULARY,
  VOCABULARY_LIST_DRILLDOWN_ADDING_STATE_SAVING_VOCABULARY,
  VOCABULARY_LIST_DRILLDOWN_ADD_TERMS,

  VOCABULARY_LIST_DRILLDOWN_APPLY_WEIGHT_TO_SELECTED,
  VOCABULARY_LIST_DRILLDOWN_SET_ADDING_VOCABULARY_IS_REPLACE,
  VOCABULARY_LIST_DRILLDOWN_SET_ADDING_STATE,

  VOCABULARY_LIST_DRILLDOWN_SET_NEW_VOCABULARY_TERMS,
  VOCABULARY_LIST_DRILLDOWN_SET_NEW_VOCABULARY_WEIGHT,
  VOCABULARY_LIST_DRILLDOWN_ADDING_VOCABULARY_RESET,
  VOCABULARY_LIST_DRILLDOWN_SET_TAB_KEY,
} from './terminusDrilldownConstants';

import { updateAction, makeSetValueAction, makeAction, keyToValueAction } from '../utils';
import TermObject from '../models/VocabularyListTermObject';

// ------------ ACTIONS

const mutators = new Map();

/**
 * "Terms" is an array of vocabularies.
 *
 * "Term" is a single vocabulary with a name and a set of words
 *
 * "Term Words/Words" are the terms in that vocabulary
 *
 * SOURCE DATA
 *
 * {
  "vocabularies": [ // <-- all the terms
    {               // <-- one term
      "vocabularyName": "Custom_Vocab_US",
      "vocabularyType": "terms",
      "terms": [     // <-- term words / words
        {
          "term": "cash conversion cycle"
        },
        {
          "term": "service provider"
        },
        {
          "term": "voice based"
        },
        {
          "term": "experience"
        },
        {
          "term": "customer"
        }
      ]
    },
    {
      "vocabularyName": "NullTermsCustomVocab",
      "vocabularyType": "terms",
      "terms": [
        {
          "term": "capella group"
        },
        {
          "term": "crowds"
        }
      ]
    },
 *
 *
 */

const providers = {
  fetchVocabulary: makeAction(mutators, VOCABULARY_LIST_DRILLDOWN_FETCH_TERM, _.identity),
  setCurrentVocabularyNameID: makeAction(mutators, VOCABULARY_LIST_DRILLDOWN_SET_CURRENT_VOCABULARY_NAME, (state, vocabularyName) => {
    if (vocabularyName === 'new') {
      return ({
        ...state,
        vocabularyName,
        currentTermEditedName: vocabularyName === 'new' ? '' : vocabularyName,
        terms: [],
        termsEditing: [],
        termState: VOCABULARY_LIST_DRILLDOWN_VOCABULARY_STATE_LOADED,
      });
    }
    return ({
      ...state,
      vocabularyName,
      currentTermEditedName: vocabularyName === 'new' ? '' : vocabularyName,
    });
  }),
  setTerm: makeAction(mutators, VOCABULARY_LIST_DRILLDOWN_SET_TERM, (state, { id, term }) => {
    const oldTermsEditing = _.get(state, 'termsEditing');
    if (!oldTermsEditing) return state;
    const termsEditing = [...oldTermsEditing];
    const i = _.findIndex(termsEditing, { id });
    if (i >= 0) {
      const match = termsEditing[i];
      match.term = term;
      return { ...state, termsEditing };
    }
    return state;
  }),
  initNewPredefinedVocabulary: updateAction(mutators, VOCABULARY_LIST_DRILLDOWN_INIT_NEW, () => ({
    name: '',
    currentTermEditedName: '',
    terms: [],
    termsEditing: TermObject.toList([]),
    termState: VOCABULARY_LIST_DRILLDOWN_VOCABULARY_STATE_LOADED,
  })),
  setTermWeight: makeAction(mutators, VOCABULARY_LIST_DRILLDOWN_SET_TERM_WEIGHT, (state, { id, weight }) => {
    const oldTermsEditing = _.get(state, 'termsEditing');
    if (!oldTermsEditing) return state;
    const termsEditing = [...oldTermsEditing];
    const i = _.findIndex(termsEditing, { id });
    if (i >= 0) {
      const match = termsEditing[i].clone();
      match.weight = weight;
      termsEditing[i] = match;
      return { ...state, termsEditing };
    }
    return state;
  }),
  setSoundsLike: makeAction(mutators, VOCABULARY_LIST_DRILLDOWN_SET_SOUNDSLIKE, (state, { id, soundsLike }) => {
    const oldTermsEditing = _.get(state, 'termsEditing');
    if (!oldTermsEditing) return state;
    const termsEditing = [...oldTermsEditing];
    const i = _.findIndex(termsEditing, { id });
    if (i >= 0) {
      const match = termsEditing[i].clone();
      match.soundsLike = soundsLike;
      termsEditing[i] = match;
      return { ...state, termsEditing };
    }
    return state;
  }),
  addKeywords: makeAction(mutators, VOCABULARY_LIST_DRILLDOWN_ADD_TERMS, (state, terms) => {
    if (!(terms && Array.isArray(terms))) {
      return { ...state };
    }
    return { ...state, termsEditing: TermObject.toList(state.termsEditing, terms) };
  }),
  setListIsNew: keyToValueAction(mutators, VOCABULARY_LIST_DRILLDOWN_SET_IS_NEW, 'listIsNew'),
  setTermState: keyToValueAction(mutators, VOCABULARY_LIST_DRILLDOWN_SET_VOCABULARY_STATE, 'termState'),
  setTermStateLoaded: makeSetValueAction(mutators, VOCABULARY_LIST_DRILLDOWN_SET_VOCABULARY_STATE_LOADED, 'termState', VOCABULARY_LIST_DRILLDOWN_VOCABULARY_STATE_LOADED),
  setTermStateNotLoaded: makeSetValueAction(mutators, VOCABULARY_LIST_DRILLDOWN_SET_VOCABULARY_STATE_NOT_LOADED, 'termState', VOCABULARY_LIST_DRILLDOWN_VOCABULARY_STATE_NOT_LOADED),
  setTermStateLoading: makeSetValueAction(
    mutators, VOCABULARY_LIST_DRILLDOWN_SET_VOCABULARY_STATE_LOADING,
    'termState', VOCABULARY_LIST_DRILLDOWN_VOCABULARY_STATE_LOADING,
  ),
  setTermStateLoadError: makeSetValueAction(mutators, VOCABULARY_LIST_DRILLDOWN_SET_VOCABULARY_STATE_LOAD_ERROR, 'termState', VOCABULARY_LIST_DRILLDOWN_VOCABULARY_STATE_LOAD_ERROR),
  setTerms: makeSetValueAction(mutators, VOCABULARY_LIST_DRILLDOWN_SET_CURRENT_VOCABULARY_TERMS, 'terms'),

  // actions for editing

  setEditingTermName: keyToValueAction(mutators, VOCABULARY_LIST_DRILLDOWN_SET_EDITING_VOCABULARY_NAME, 'currentTermEditedName'),
  setEditingSearchTerm: keyToValueAction(mutators, VOCABULARY_LIST_DRILLDOWN_EDITING_SET_SEARCH_TERM, 'searchTerm'),
  setIsEditingVocabulary: keyToValueAction(mutators, VOCABULARY_LIST_DRILLDOWN_EDITING_SET_IS_EDITING_VOCABULARY, 'isEditingVocabulary'),
  destroyVocabulary: makeSetValueAction(mutators, VOCABULARY_LIST_DRILLDOWN_EDITING_DESTROY, 'isEditingVocabulary', false),
  // destroyVocabulary triggers saga
  saveEdits: makeAction(mutators, VOCABULARY_LIST_DRILLDOWN_EDITING_SAVE, _.identity),
  // saveEdits triggers saga
  setEditingTerms: makeAction(mutators, VOCABULARY_LIST_DRILLDOWN_SET_EDITING_VOCABULARY_TERMS, (state, termsEditing) => ({ ...state, termsEditing: TermObject.toList(termsEditing, state.editingVocabularyWeight) })),
  applyWeight: makeAction(mutators, VOCABULARY_LIST_DRILLDOWN_APPLY_WEIGHT_TO_SELECTED, (state) => {
    const { termsEditing, termsCheckList, editingVocabularyWeight } = state;
    // find the edited terms that are checked
    /**
     * note - because selected terms are items from termsEditing,
     * when we edit its' weights, we are editing the termsEditing terms' weights.
     */
    const selectedTerms = termsEditing.filter(term => termsCheckList.includes(term.term));
    selectedTerms.forEach((t) => {
      // eslint-disable-next-line no-param-reassign
      t.weight = editingVocabularyWeight;
    });
    return Object.assign({}, state, {
      termsEditing: termsEditing.map(t => _.cloneDeep(t)),
      termsCheckList: [],
    });
  }),

  deleteCheckedTerms: makeAction(mutators, VOCABULARY_LIST_DRILLDOWN_DELETE_CHECKED_TERMS, (state) => {
    const { termsEditing, termsCheckList } = state;
    const remainingTerms = termsEditing.filter(term => !termsCheckList.includes(term.id));
    return Object.assign({}, state, {
      termsEditing: TermObject.toList(remainingTerms),
      termsCheckList: [],
    });
  }),
  setTermCheckList: keyToValueAction(mutators, VOCABULARY_LIST_DRILLDOWN_EDITING_SET_CURRENT_TERM_CHECKLIST, 'termsCheckList'),
  setEditingVocabularyWeight: keyToValueAction(mutators, VOCABULARY_LIST_DRILLDOWN_SET_EDIT_VOCABULARY_WEIGHT, 'editingVocabularyWeight'),
  setEditingState: keyToValueAction(mutators, VOCABULARY_LIST_DRILLDOWN_SET_EDITING_STATE, 'editingState'),
  setEditingStateNotLoaded: makeSetValueAction(mutators, VOCABULARY_LIST_DRILLDOWN_SET_EDITING_STATE_NOT_LOADED, 'editingState', VOCABULARY_LIST_DRILLDOWN_EDITING_STATE_NOT_LOADED),
  setEditingStateLoading: makeSetValueAction(mutators, VOCABULARY_LIST_DRILLDOWN_SET_EDITING_STATE_LOADING, 'editingState', VOCABULARY_LIST_DRILLDOWN_EDITING_STATE_LOADING),
  setEditingStateLoaded: makeSetValueAction(mutators, VOCABULARY_LIST_DRILLDOWN_SET_EDITING_STATE_LOADED, 'editingState', VOCABULARY_LIST_DRILLDOWN_EDITING_STATE_LOADED),
  setEditingStateLoadError: makeSetValueAction(mutators, VOCABULARY_LIST_DRILLDOWN_SET_EDITING_STATE_LOAD_ERROR, 'editingState', VOCABULARY_LIST_DRILLDOWN_EDITING_STATE_ERROR),
  editingWordsReset: makeAction(mutators, VOCABULARY_LIST_DRILLDOWN_EDITING_RESET, state => Object.assign({}, state, {
    searchTerm: '',
    termsCheckList: [],
    isEditingVocabulary: false,
  })),

  // actions for adding words en masse

  setAddingVocabularyIsReplace: keyToValueAction(mutators, VOCABULARY_LIST_DRILLDOWN_SET_ADDING_VOCABULARY_IS_REPLACE, 'addingVocabularyIsReplace'),
  setAddingState: keyToValueAction(mutators, VOCABULARY_LIST_DRILLDOWN_SET_ADDING_STATE, 'addVocabularyState'),
  // triggers saga
  saveAddingTerms: makeAction(mutators, VOCABULARY_LIST_DRILLDOWN_SAVE_ADDING_VOCABULARY_TERMS, _.identity),
  setAddingStateNotAdding: makeSetValueAction(mutators, VOCABULARY_LIST_DRILLDOWN_STOP_ADDING_VOCABULARY, 'addVocabularyState', VOCABULARY_LIST_DRILLDOWN_ADDING_STATE_NOT_ADDING_VOCABULARY),
  setAddingStateAdding: makeSetValueAction(mutators, VOCABULARY_LIST_DRILLDOWN_START_ADDING_VOCABULARY, 'addVocabularyState', VOCABULARY_LIST_DRILLDOWN_ADDING_STATE_ADDING_VOCABULARY),
  setAddingStateSaving: makeSetValueAction(mutators, VOCABULARY_LIST_DRILLDOWN_SAVE_ADDING_VOCABULARY, 'addVocabularyState', VOCABULARY_LIST_DRILLDOWN_ADDING_STATE_SAVING_VOCABULARY),
  setAddVocabularyTerms: keyToValueAction(mutators, VOCABULARY_LIST_DRILLDOWN_SET_NEW_VOCABULARY_TERMS, 'addingVocabularyTerms'),
  setAddVocabularyWeight: keyToValueAction(mutators, VOCABULARY_LIST_DRILLDOWN_SET_NEW_VOCABULARY_WEIGHT, 'addingVocabularyWeight'),
  addingVocabularyReset: makeAction(mutators, VOCABULARY_LIST_DRILLDOWN_ADDING_VOCABULARY_RESET, state => Object.assign({}, state, {
    addingVocabularyName: '',
    tabKey: 'preview',
    addingVocabularyTerms: [],
    addingVocabularyWeight: 0,
    addingVocabularyIsReplace: true,
  })),
  setTabKey: keyToValueAction(mutators, VOCABULARY_LIST_DRILLDOWN_SET_TAB_KEY, 'tabKey'),
};

// -------------- RESOLVER

const initialValue = {
  tabKey: 'preview',
  termsCheckList: [],
  editingVocabularyWeight: 0,
  currentTermEditedName: '',
  isEditingVocabulary: false,
  vocabularyName: null,
  listIsNew: false,
  designatedWeight: 0,
  terms: [],
  termsEditing: [],
  searchTerm: '',
  termState: VOCABULARY_LIST_DRILLDOWN_VOCABULARY_STATE_NOT_LOADED,
  addVocabularyState: VOCABULARY_LIST_DRILLDOWN_ADDING_STATE_NOT_ADDING_VOCABULARY,
  addingVocabularyTerms: [],
  addingVocabularyWeight: 0,
  addingVocabularyIsReplace: true,
};

const resolver = (state = initialValue, { type, payload }) => {
  if (!mutators.has(type)) {
    return state;
  }

  return mutators.get(type)(state, payload);
};

export default resolver;

const actions = Array.from(mutators.keys());

export {
  actions,
  providers,
};
